import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getTrades = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `trade`);
};
export const getTradesDetail = (trade_code: string) => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `trade/` + trade_code);
};
export const GetById = (Id: number) => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `trade/` + Id);
};
export const tradeUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `trade/update`, obj, {
    headers,
  });
};
export const tradeDelete = (obj: Object) => {
  return axios.put(GetBackendUrlForGlobalFunctions() + `trade/delete`, obj);
};
export const tradeDeleteList = (List: Object[]) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `trade/delete_list`,
    List
  );
};
export const createTrade = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `trade/add`, obj, {
    headers,
  });
};
